import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { TextField, IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons'
import ButtonBase from '../../../components/Buttons/ButtonBase';
import './AddACC.scss'

const useStyles = makeStyles({
    textField: {
        minWidth: 416,
        margin: '0 0 32px 0',
        height: 'auto',
        padding: 0,
    },
    linkStyle: {
        display: 'flex',
        justifyContent: 'center',
    },
    buttonStyle: {
        minWidth: 304,
        margin: '24px 0 0 0',
    },
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0
    },
})

const AddACCForm = (props) => {

    const {
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        touched,
        errors,
        isValid,
        isModal
    } = props;

    const classes = useStyles()

    const [valuesPass, setValuesPass] = useState({
        password: '',
        showPassword: false,
      });

    const handleClickShowPassword = () => {
        setValuesPass({
            ...valuesPass,
            showPassword: !valuesPass.showPassword
        });
    };

    return (
        <form className={isModal ? 'addACCFormModal' : 'addACCForm'}>
            <TextField
                label="Nombre completo*"
                id="names"
                type="text"
                variant="outlined"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.names ? values.names : ''}
                helperText={
                    touched.names && errors.names
                    ? errors.names
                    : ''
                }
                error={touched.names && errors.names ? true : false}
                className={classes.textField}
            />

            <TextField
                label="Correo electrónico*"
                id="email"
                type="text"
                variant="outlined"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email ? values.email : ''}
                helperText={
                    touched.email && errors.email
                    ? errors.email
                    : ''
                }
                error={touched.email && errors.email ? true : false}
                className={classes.textField}
            />

            <TextField
                id="outlined-adornment-password"
                variant="outlined"
                type={valuesPass.showPassword ? 'text' : 'password'}
                label="Contraseña*"
                name='password'
                className={classes.textField}
                value={values.password ? values.password : ''}
                onBlur={handleBlur}
                onChange={handleChange}
                helperText={
                    touched.password && errors.password
                    ? errors.password
                    : ''
                }
                error={touched.password && errors.password ? true : false}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="Toggle password visibility"
                                onClick={handleClickShowPassword}
                                classes={{
                                    root: classes.colorGrayIcon
                                }}
                            >
                                {valuesPass.showPassword ?
                                    <VisibilityOff /> :
                                    <Visibility />
                                }
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
                
            <ButtonBase
                type="submit"
                onClick={handleSubmit}
                variant="primary"
                disabled={!isValid}
                linkStyle={classes.linkStyle}
                buttonStyle={classes.buttonStyle}
            >
                Crear usuario
            </ButtonBase>
        </form>
    )
}

export default AddACCForm;
